import { Pipe, PipeTransform } from '@angular/core';
import { CacheService } from '../../../services/sys/cache.service';
import { StaticsService } from '../../../services/sys/statics.service';

/**
 * Converts a string value to YES/NO/DON'T KNOW text.
 * 
 * @value the string to convert ("1", "2", "3") are valid values
 */
@Pipe({
    name: 'yesNoString',
    standalone: false
})
export class YesNoString implements PipeTransform {
    
    constructor(private staticsService: StaticsService,
                private cacheService: CacheService) {}
    
	transform(value : string): string {
		if (value == this.staticsService.getYesNoRadio().YES) {
            return this.cacheService.getDropDownTextFromVal("OptionText.YesNoDontKnowChoices", "1");
        } else if (value == this.staticsService.getYesNoRadio().NO) {
            return this.cacheService.getDropDownTextFromVal("OptionText.YesNoDontKnowChoices", "2");
        } else if (value == this.staticsService.getYesNoRadio().DONT_KNOW) {
            return this.cacheService.getDropDownTextFromVal("OptionText.YesNoDontKnowChoices", "3");
        } else {
            return "";
        }
	}
    
}